export default __webpack_public_path__ + "static/media/ajk-home.73f3c4bf.jpeg";